import React, { useEffect, useState } from 'react';
import { Button, Input, message, Modal, Select } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import IconAdd from 'assets/images/IconAdd.svg';
import IconUpload from 'assets/images/IconUpload.svg';
import IconNotify from 'assets/images/IconNotify.svg';

import { getListClassDropdown } from 'requests/class';
import _ from 'lodash';

const { Search } = Input;
const { confirm } = Modal;

const ClassSelect = ({ selectedClass, onChangeClass }) => {
    const [loading, setLoading] = useState(false);
    const [classes, setClasses] = useState([]);
    const [take, setTake] = useState(20);
    const [total, setTotal] = useState(21);
    const [search, setSearch] = useState('');
    const { t } = useTranslation();

    useEffect(() => {
        getData();
    }, [take, search]);

    const getData = async () => {
        try {
            setLoading(true);

            const data = await getListClassDropdown({ take, search });
            const classOptions = data.records.map((records) => {
                return { label: records.className, value: records.id };
            });

            setTotal(data.total);
            setClasses(classOptions);
        } catch (err) {
            console.log(err);
            message.error(t(err.response?.data.message || 'error'));
        } finally {
            setLoading(false);
        }
    };

    const handleScroll = (e) => {
        const target = e.target;
        if (!loading && take < total && target.scrollTop + target.offsetHeight >= target.scrollHeight - 10) {
            setTake(take + 10);
        }
    };

    const handleSearch = _.debounce(setSearch, 400);

    return (
        <div className="select-add-student-class">
            <Select
                showSearch
                filterOption={false}
                onSearch={handleSearch}
                placeholder={t('add_class')}
                optionFilterProp="children"
                onChange={onChangeClass}
                optionLabelProp="label"
                options={classes}
                onPopupScroll={handleScroll}
                onDropdownVisibleChange={() => setSearch('')}
                value={selectedClass}
            ></Select>
        </div>
    );
};

const TableAction = ({
    query,
    searchPlaceholder,
    disableDeleteBtn,
    onSearch,
    onDelete,
    onAdd,
    selectedClass,
    showClassSelect,
    onChangeClass,
    disableAddClassBtn,
    onUpload,
    onNotify,
}) => {
    const [keyword, setKeyword] = useState('');
    const { t } = useTranslation();

    useEffect(() => {
        setKeyword(query.search);
    }, [query]);

    const handleClickDeleteBtn = () => {
        // modal confirm
        confirm({
            title: t('confirm_delete_many'),
            icon: <ExclamationCircleOutlined />,
            cancelText: t('cancel'),
            onOk() {
                onDelete();
            },
        });
    };

    const handleChangeKeyword = (value) => {
        setKeyword(value);
    };

    const handleSearch = (value) => {
        value = value.trim();
        setKeyword(value);
        onSearch(value);
    };

    return (
        <div className="table-action">
            <div className="search-box">
                {searchPlaceholder && (
                    <Search
                        value={keyword}
                        placeholder={searchPlaceholder}
                        onChange={(e) => handleChangeKeyword(e.target.value)}
                        onSearch={handleSearch}
                        style={{
                            width: 266,
                            height: 32,
                        }}
                    />
                )}
                {showClassSelect && <ClassSelect onChangeClass={onChangeClass} selectedClass={selectedClass} />}
                {onDelete && (
                    <Button
                        type="default"
                        danger
                        className="delete-btn"
                        disabled={disableDeleteBtn}
                        onClick={handleClickDeleteBtn}
                    >
                        {t('delete')}
                    </Button>
                )}
                {onAdd && (
                    <Button type="primary" danger className="add-btn" onClick={onAdd}>
                        <img src={IconAdd} alt="" />
                        <span>{t('add_new')}</span>
                    </Button>
                )}
                {onNotify && (
                    <Button type="primary" danger className="notify-btn" onClick={onNotify} disabled={disableDeleteBtn}>
                        <img src={IconNotify} alt="" />
                        <span>{t('notify')}</span>
                    </Button>
                )}
                {onUpload && (
                    <label>
                        <input type="file" onInput={onUpload} style={{ display: 'none' }} />
                        <div type="primary" className="ant-btn ant-btn-primary ant-btn-dangerous upload-btn ml-24">
                            <img src={IconUpload} alt="" />
                            <span>{t('upload')}</span>
                        </div>
                    </label>
                )}
            </div>
        </div>
    );
};

export default TableAction;
